import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NotificationProvider } from '@vlabs/monokit/shared/ui/notification-provider';
import { WhiteLabelBrand } from '@vlabs/monokit/shared/ui/white-label-brand';
import { ResetPasswordPage, LoginPage } from '@vlabs/pages/auth';
import { ThemeProvider } from '@vlabs/shared/context/ThemeContext';
import { ScrollToTop } from '@vlabs/shared/utils';
import { useSelector } from 'react-redux';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import { selectIsAuthenticated } from '@vlabs/pages/auth/selectors';

import { ClementineNavbar } from './navigation';
import { ClementineRouter } from './router';

const queryClient = new QueryClient();

function ClementineApp(): React.JSX.Element {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return (
    <ThemeProvider>
      <BrowserRouter>
        <div style={{ display: 'flex', minHeight: '100svh' }}>
          <ScrollToTop />

          {!isAuthenticated && (
            <Switch>
              <Route
                component={ResetPasswordPage}
                path="/auth/reset/:token"
              />
              <Route
                path="*"
                render={() => (<LoginPage CustomBrand={<WhiteLabelBrand style={{ backgroundPosition: 'center' }} />} />)}
              />
            </Switch>
          )}

          {!!isAuthenticated && (
            <React.Fragment>
              <ClementineNavbar />
              <QueryClientProvider client={queryClient}>
                <NotificationProvider>
                  <ClementineRouter />
                </NotificationProvider>
              </QueryClientProvider>
            </React.Fragment>
          )}
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export { ClementineApp };
